import { HttpClient, HttpHeaders, HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { async, BehaviorSubject, observable, Observable, of, throwError } from 'rxjs';
import { environment } from '../../../../environments/environment';
import qnsbnurlAPI from  '../../qn-sbn-eservices/services/qn-sbn-API-url';
import { AppUtils } from '../../../shared/utilities/app-utils';
import { OneSnackBarService, OneSnackBarType } from '@one/angular-kit/modal';
import { Router } from '@angular/router';
import { QnSbnDataService } from './qn-sbn-data-service.service';
import { affiliateFallbackData } from './affiliates-data';
import { promises } from 'dns';

@Injectable({
  providedIn: 'root'
})
export class QnSbnService {
  public accessToken:string = '';
  public fileSizeU:string;
  public notificationID: any;
  public notificationsData: any;
  public userRole: any = {
    CreateNotification: true,
    SendNotification: true,
    UserAdmin: false,
    ViewNotification: true
  };
  public userData: any;
  public UserCountries: any = [];
  public contactsData: any;
  public baseUrl = `${window.location.origin}/api/`; 
  public header =  {};

  // to toggle render of Unauth msg in notification.component.html
  public isAuthUser: boolean = false;
  public isError: boolean = false;
  public errorMsg: any;
  
  public constructor(public http: HttpClient, public appUtil: AppUtils, public readonly oneSnackBar: OneSnackBarService,public _QnSbnDataService:QnSbnDataService,public router: Router) {}

  public getLocalStorageItem(text:string) {
    for (let i = 0; i < localStorage.length; i++) {
      const lsKeyName: string = localStorage.key(i);
      if (lsKeyName.includes(text)) {
        return localStorage.getItem(lsKeyName);
      }
    }
  }

  public setAccessToken(access_token:string) {
    this.accessToken = access_token;
  }

  public setLocalNotificationID(notificationId) {
    this.notificationID = notificationId;
  }
  public getLocalNotificationID(){
    return this.notificationID;
  }

  public getQnSbnService(url:string): Observable<any> {
    return this.http.get(url);
  }
 
  public postQnSbnService(url:string,data?:any): Observable<any> {
    return this.http.post(url, data);
  }
  
  public putQnSbnService(url:string, data?:any): Observable<any> {
    return this.http.put(url, data);
  }

  dataToBeSaveOnS3(saveNCloseData, fileToBeUpload,notificationIdP?,isLastFile?, isSendNotification?){
    
    if(fileToBeUpload){
      let filename = fileToBeUpload.name;
      this.getQnSbnService(this.baseUrl + qnsbnurlAPI.getSignedURLForFileUpload + filename +"&NotificationId="+ notificationIdP + "&Verify=" + false).subscribe(async res=>{   
        if(res){
         
          let uploadURL = res['body'];
          const httpOptions = {
            headers: new HttpHeaders({
              "Content-Type": "application/octet-stream",
              "Accept": '*/*'
            })
          };

          this.http.put(uploadURL,fileToBeUpload,httpOptions).subscribe(d=>{
            this.getQnSbnService(this.baseUrl + qnsbnurlAPI.getSignedURLForFileUpload + filename +"&NotificationId="+ notificationIdP + "&Verify=" + true).subscribe(async res=>{
              if(res){
                if(isLastFile && isSendNotification){
                  sessionStorage.setItem('reloadOverview', 'true'); 
                  this.sendNotificationData(saveNCloseData).subscribe(res=>{
                    this._QnSbnDataService.resetAll();
                    this.router.navigateByUrl('/notification');
                    this.oneSnackBar.open('Notification sent successfully', OneSnackBarType.SUCCESS, '', { duration: 5000 });
                  },(error: HttpErrorResponse) => {
                    this.httpErrorHandler(error, 'Sending local notification failed.');
                  })
                } else if(isLastFile && isSendNotification === false) {
                  sessionStorage.setItem('reloadOverview', 'true'); 
                  this.saveNCloseNotificationData(saveNCloseData).subscribe(res=>{
                    this._QnSbnDataService.resetAll();
                    this.router.navigateByUrl('/notification');
                    this.oneSnackBar.open('Local notification saved successfully', OneSnackBarType.SUCCESS, '', { duration: 5000 });
                  },(error: HttpErrorResponse) => {
                    this.httpErrorHandler(error, 'Local notification not saved successfully');
                  })
                }
              }else{
                this.oneSnackBar.open('Send or Save local notification failed.', OneSnackBarType.ERROR, '', { duration: 5000 });
              }
            },
            (err)=>{
              this.oneSnackBar.open('Local uploaded File size is Zero and Send Notification Failed', OneSnackBarType.ERROR, '', { duration: 5000 });
            });
          },
          (err)=>{
            this.oneSnackBar.open('Send or Save local notification failed.', OneSnackBarType.ERROR, '', { duration: 5000 });
          });
        }
      });
    }
  }

  uniqueIdPiosDocSearch(urlSuffix:any): Observable<any> {
    const apiurl = this.baseUrl + qnsbnurlAPI.PIOSMetadata + urlSuffix;
    return this.http.get(apiurl);
  }

  notificationDocPiosDocSearch(urlSuffix:any): Observable<any> {
    const apiurl = this.baseUrl + qnsbnurlAPI.PIOSMetadata + urlSuffix;
    return this.http.get(apiurl);
  }

  addNewRecipientList(data:any): Observable<any> {
    const apiurl = this.baseUrl + qnsbnurlAPI.contactNotification;
    return this.http.post(apiurl, data);
  }

  createNotificationUniqueId(data:any): Observable<any> {
    const apiurl = this.baseUrl + qnsbnurlAPI.globalNotification;
    return this.http.post(apiurl, data);
  }

  saveNCloseNotificationData(data:any): Observable<any> {
    const apiurl = this.baseUrl + qnsbnurlAPI.globalNotification;
    return this.http.put(apiurl, data);
  }

  sendNotificationData(data:any): Observable<any> {
    const apiurl = this.baseUrl + qnsbnurlAPI.sendNotificationAPI;
    return this.http.put(apiurl, data);
  }

  public postResendNotifications(data:any): Observable<any> {
    const apiurl = this.baseUrl + qnsbnurlAPI.resendNotificationAPI;
    return this.http.post(apiurl, data);
  }

  /* Get FeedBack Data start*/
  getFeedbackDetails(notificationId:string, contactNotificationId: Array<any>): Observable<any> {
    const FeedbackDetailsApi = {
      NotificationId : notificationId,
      ContactNotificationIds: contactNotificationId
    }
    const FeedbackDetailsJson= JSON.stringify(FeedbackDetailsApi);
    const apiurl = this.baseUrl + qnsbnurlAPI.getFeedBackDetails;
    return this.http.post(apiurl, FeedbackDetailsJson);
  }
  /* Get FeedBack Data start End*/

  /*Set Notification status Complete*/
  setNotificationStatus(stausData:any): Observable<any> {
    const apiurl = this.baseUrl + qnsbnurlAPI.setNotificationURL;
    return this.http.put(apiurl, stausData);
  }
  /*Set Notification status Complete*/

  downloadPiosDocumentApi(globalNotificationId, fileExtension) {
    const apiurl = this.baseUrl + qnsbnurlAPI.downloadDocument + globalNotificationId;
    this.appUtil.fetchDoc(apiurl, '',this.accessToken, fileExtension);
  }

 downloadLocalAttachmentApi(filename:string, notificationId:string, accountNotificationId?: string, attachment?: string) {
    let apiurl;
    if(accountNotificationId && attachment){
      apiurl = this.baseUrl + qnsbnurlAPI.downloadAttachment + "Filename="+filename+"&NotificationId="+notificationId+"&AccountNotificationId="+accountNotificationId+"&Attachment="+attachment;
    } else {
      apiurl = this.baseUrl + qnsbnurlAPI.downloadAttachment + "Filename="+filename+"&NotificationId="+notificationId;
    }
    this.getQnSbnService(apiurl).subscribe(res => {
      if(res){
        let downloadURL = res['body'];
        fetch(downloadURL)
          .then(response => response.blob())
          .then(blob => {
            const link = document.createElement('a');
            link.href = URL.createObjectURL(blob);
            link.download = filename;
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
          });
      }
    });
  }

  downloadLSOAttachmentApi(filename:string, notificationId:string, contactNotificationId:string) {
    const apiurl = this.baseUrl + qnsbnurlAPI.downloadAttachment 
    +"Filename="+filename
    +"&NotificationId="+notificationId
    +"&ContactNotificationId="+contactNotificationId;
    this.getQnSbnService(apiurl).subscribe(res=>{
      if(res){
        let downloadURL = res['body'];
        fetch(downloadURL)
          .then(response => response.blob())
          .then(blob => {
            const link = document.createElement('a');
            link.href = URL.createObjectURL(blob);
            link.download = filename;
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
          });

      }
    });
  }

  qnSbnNotificationInitCall(): Observable<any> {
    const apiurl = this.baseUrl + qnsbnurlAPI.userDetails;
    return this.http.get(apiurl);
  }

  getNotificationOverviewData(type:[''], status:[''], country:['']) {
    const apiurl = this.baseUrl 
    + qnsbnurlAPI.notificationDetail
    +"?typeFilter="+type
    +"&statusFilter="+status
    +"&countryFilter="+country;
    return this.http.get(apiurl);
  }
  
  getNotificationContactDetails(notificationId:string): Observable<any> {
    const apiurl = this.baseUrl + qnsbnurlAPI.contactDetails + notificationId;
    return this.http.get(apiurl);
  }

  viewReminderLocal(notificationId: string): Observable<any> {
    const apiurl = `${this.baseUrl}${qnsbnurlAPI.viewReminderLocal}?notificationid=${encodeURIComponent(notificationId)}`;
    return this.http.get(apiurl);
  }

  setNotificationData(data:any) {
    this.notificationsData = data;
    sessionStorage.setItem('reloadOverview', 'false');
  }

  getNotificationData() {
    return this.notificationsData;
  }

  setUserData(data:any) {
    if(Array.isArray(data)) {
      if(data[0].userGroupData && data[0].userGroupData.permissions) {
        this.userData = data[0].userGroupData;
        this.userRole = data[0].userGroupData.permissions;
        this.UserCountries = data[0].userGroupData.countries;
      }
    } else {
      if(data.userGroupData && data.userGroupData.permissions) {
        this.userData = data.userGroupData;
        this.userRole = data.userGroupData.permissions;
        this.UserCountries = data.userGroupData.countries;
      }
    }
    sessionStorage.setItem('UserRole', JSON.stringify(this.userRole));
    sessionStorage.setItem('UserCountries', this.userData.countries);
  }

  getUserData() {
    return this.userRole;
  }

  getUserAllData() {
    return this.userData;
  }

  getUserCountries() {
    return this.UserCountries;
  }

  EditCustomerData(CustomerDetails:any): Observable<any> {
    const apiurl = this.baseUrl + qnsbnurlAPI.contactNotification;
    return this.http.put(apiurl, CustomerDetails);
  }
  
  httpErrorHandler(error: any, errMessage: string) {
    if(error.status === 401) {
      this.oneSnackBar.open('Token Expire, Please login again.', OneSnackBarType.ERROR, '', { duration: 5000 });
      setTimeout(function(){
        window.location.reload();
      }, 2000);
    } else if(error.status === 403) {
      this.oneSnackBar.open(errMessage, OneSnackBarType.ERROR, '', { duration: 7000 });
    } else if(error.status === 404) {
      // this.oneSnackBar.open('No data found or Invalid data. Please check and try again later.', OneSnackBarType.ERROR, '', { duration: 5000 });
    }
    else {
      this.oneSnackBar.open(errMessage, OneSnackBarType.ERROR, '', { duration: 5000 });
    }
  }

  public getNotificationLanguage(country: string): string {
    if(country) {
      const affiliateData = affiliateFallbackData;
      const notificationCountry = country.toLowerCase();
      const chosenAffiliate = affiliateData.find(affilate => affilate.affiliate.toLowerCase() === notificationCountry);
      return chosenAffiliate?.defaultLanguage || 'en_US';
    }
  }

  public getMessageTemplate(notificationType:string, language:string): Observable<any> {
    const apiurl = this.baseUrl + qnsbnurlAPI.getMessageTemplate + '&notificationtype='+notificationType+'&language='+language;
    return this.http.get(apiurl);
  }

  public getReminderTemplate(notificationType:string, language:string): Observable<any> {
    const apiurl = this.baseUrl + qnsbnurlAPI.getReminderTemplate + '&notificationtype='+notificationType+'&language='+language;
    return this.http.get(apiurl);
  }
 
  public createUpdateMessageTemplate(data:any): Observable<any> {
    const apiurl = this.baseUrl + qnsbnurlAPI.addUpdateMessageTemplate;
    return this.http.post(apiurl, data);
  }

  public deleteMessageTemplate(templateId:string): Observable<any> {
    const apiurl = this.baseUrl + qnsbnurlAPI.deleteMessageTemplate + templateId;
    return this.http.get(apiurl);
  }

  public fetchCSV(data:any): Observable<any> {
    const apiurl = this.baseUrl + qnsbnurlAPI.fetchCsvReport;
    return this.http.post(apiurl, data);
  }

  downloadEmailEvidenceApi(notificationId:string, filename:string, CustomerContactEmail:string) {
    const apiurl = this.baseUrl 
    + qnsbnurlAPI.downloadEmailEvidence
    +"?NotificationId="+notificationId
    +"&Filename="+encodeURIComponent(filename)
    +"&CustomerContactEmail="+encodeURIComponent(CustomerContactEmail);

    this.getQnSbnService(apiurl).subscribe(
      res => {
        let downloadURL = res['body'];
        this.appUtil.fetchDoc(downloadURL, '', '', filename+'.pdf');
      }
    );
  }

  public deleteDraftNotification(notificationID:string): Observable<any> {
    const apiurl = this.baseUrl + qnsbnurlAPI.deleteDraftNotification+ notificationID;
    return this.http.get(apiurl);
  }


  public fileAckSaveOnS3(fileToBeUpload,contactNotificationId, notificationId ): Observable<any>{
    if(fileToBeUpload){
      let filename = fileToBeUpload.name;
      this.getQnSbnService(this.baseUrl + qnsbnurlAPI.getSignedURLForCustomerFileUpload +"?Filename="+ filename +"&ContactNotificationId="+contactNotificationId+"&NotificationId="+ notificationId + "&Verify=" + false).subscribe(async res=>{
        if(res){
          let uploadURL = res['body'];
          const httpOptions = {
            headers: new HttpHeaders({
              "Content-Type": "application/octet-stream",
              "Accept": '*/*'
            })
          };
          this.http.put(uploadURL,fileToBeUpload,httpOptions).subscribe(d=>{
            this.getQnSbnService(this.baseUrl + qnsbnurlAPI.getSignedURLForCustomerFileUpload +"?Filename="+ filename +"&ContactNotificationId="+contactNotificationId+"&NotificationId="+ notificationId + "&Verify=" + true).subscribe(
              async res=>{
                if(res){
                  this._QnSbnDataService.resetAll();
                }
              },
              (error: HttpErrorResponse) => {
                this.oneSnackBar.open(`Please try again later`, OneSnackBarType.ERROR, '', { duration: 5000 });
                return;
              }
            );
          },
          (error: HttpErrorResponse) => {
            this.oneSnackBar.open(`Failed to upload file. Please try again later.`, OneSnackBarType.ERROR, '', { duration: 5000 });
            return;
          });
        }
      });
    }
    return of(true);
  }

  public feedbackApi(feedbackApiJson){
    const apiurl = this.baseUrl + qnsbnurlAPI.feedbackAckApi;
    return this.http.post(apiurl,feedbackApiJson);
  }

  EditAccountData(AccountDetails:any): Observable<any> {
    const apiurl = this.baseUrl + qnsbnurlAPI.editAccountData;
    return this.http.put(apiurl, AccountDetails);
  }

  public getAccountList(notificationId:string): Observable<any> {
    const apiurl = this.baseUrl + qnsbnurlAPI.getAccountList + notificationId;
    return this.http.get(apiurl);
  }

  public getContactList(accountNotificationId:string): Observable<any> {
    const apiurl = this.baseUrl + qnsbnurlAPI.getContactList + accountNotificationId;
    return this.http.get(apiurl);
  }
  
  public getRexSapTaskId(
    countryCode: string, 
    accountsSource: string,
    contactsSource: string,
    instrumentMaterialNumber: [], 
    reagentMaterialNoValue: [], 
    materialBatchNoValue:[],
   // batchVal: [], 
    dateFrom: Date|null, 
    dateTo: Date|null,
    contactAttrType: string,
    contactAttrValue: string,
    contactRole: string,
    instrumentStatus: string,
    shipPartnerRole:[]
  ): Promise<any> {

    const dateFromStr = this.formatDateRexis(dateFrom);
    const dateToStr = this.formatDateRexis(dateTo);

    const apiurl = this.baseUrl + qnsbnurlAPI.getRexisSapDataUrl +
    `countryCode=${countryCode || ''}&` +
    `accountsSource=${accountsSource || ''}&` +
    `contactsSource=${contactsSource || ''}&` +
    `instrumentMaterialNumber=${instrumentMaterialNumber || ''}&` +
    `reagentMaterialNo=${reagentMaterialNoValue || ''}&` +
    `materialBatchNo=${materialBatchNoValue || ''}&` +
   // `batchVal=${batchVal || ''}&` +
    `dateFrom=${dateFromStr || ''}&` +
    `dateTo=${dateToStr || ''}&` +
    `contactAttrType=${contactAttrType || ''}&` +
    `contactAttrValue=${contactAttrValue || ''}&` +
    `contactRole=${contactRole || ''}&` +
    `instrumentStatus=${instrumentStatus || ''}&` +
    `shipPartnerRole=${shipPartnerRole || ''}`;

    return this.http.get(apiurl).toPromise();
  }
  
  public formatDateRexis(x: Date): string {
    if(x !== null){
      let y = x.getFullYear().toString();
      let m = (x.getMonth() + 1).toString();
      let d = x.getDate().toString();
      (d.length == 1) && (d = '0' + d);
      (m.length == 1) && (m = '0' + m);
      let yyyymmdd = y + m + d;
      return yyyymmdd;
    }
    if(x === null){
      return null
    }
  }

  public getRexSapPolling(mainTaskId:string): Promise<any> {
    const apiurl = this.baseUrl + qnsbnurlAPI.getRexSapPolling + mainTaskId
    return this.http.get(apiurl).toPromise();
  }

  public getNotificationAuditTrailList(notificationId:string): Observable<any> {
    const apiurl = this.baseUrl + qnsbnurlAPI.getNotificationAuditTrailData + notificationId;
    return this.http.get(apiurl);
  }

  public getContactNotificationAuditTrailList(contactNotificationId:string): Observable<any> {
    const apiurl = this.baseUrl + qnsbnurlAPI.getContactNotificationAuditTrailData + contactNotificationId;
    return this.http.get(apiurl);
  }

  public getAccountNotificationAuditTrailList(accountNotificationId:string): Observable<any> {
    const apiurl = this.baseUrl + qnsbnurlAPI.getAccountNotificationAuditTrailData + accountNotificationId;
    return this.http.get(apiurl);
  }

  public emailReportDashboard(emailDetailsJson): Observable<any> {
    const apiurl = this.baseUrl + qnsbnurlAPI.generateEmailReportAPI;
    return this.http.post(apiurl, emailDetailsJson);
  }

  public emailReportDetails(emailReportJson): Observable<any> {
    const apiurl = this.baseUrl + qnsbnurlAPI.generateemailreportdetailsAPI;
    return this.http.post(apiurl, emailReportJson);
  }

  public saveInternalNote(data:any): Observable<any> {
    const apiurl = this.baseUrl + qnsbnurlAPI.internalNotesAPI;
    return this.http.post(apiurl, data);
  }

  public statisticsReportDashboard(dashboardJson): Observable<any> {
    const apiurl = this.baseUrl + qnsbnurlAPI.generatestatisticsreportAPI;
    return this.http.post(apiurl, dashboardJson);
  }

  public createReminders(reminderData: any): Observable<any> {
    const apiurl = this.baseUrl + qnsbnurlAPI.createRemindersAPI;
    const reminderDataJson = JSON.stringify(reminderData);
    return this.http.post(apiurl, reminderDataJson);
  }
}